import { BundlePackageData } from "../../interfaces/bundlePackageGroup/BundlePackageGroup.type";
import useAppStore from "../../store/AppStore";
import BundlePackageGroupMobileContainer from "./mobile/BundlePackageGroupMobileContainer";
import BundlePackageGroupDesktopContainer from "./desktop/BundlePackageGroupDesktopContainer";

export default function BundlePackageGroupContainer({
  items,
  scroll,
}: {
  items: BundlePackageData[];
  scroll?: boolean;
}) {
  const { isDeviceMobile } = useAppStore();

  return isDeviceMobile ? (
    <BundlePackageGroupMobileContainer items={items} scroll={scroll} />
  ) : (
    <BundlePackageGroupDesktopContainer items={items} />
  );
}
